var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#173261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.38 24V7.83H10.814V10.272H7.756V14.628H9.956V17.004H7.756V21.558H10.814V24H5.38ZM11.5433 24L14.1613 15.508L11.5873 7.83H13.9193L15.2173 11.922L15.2833 12.23H15.3713L15.4373 11.922L16.7353 7.83H19.0673L16.4933 15.508L19.1113 24H16.7793L15.4153 19.182L15.3713 18.874H15.2833L15.2393 19.182L13.8753 24H11.5433ZM19.8378 24V7.83H25.2718V10.272H22.2138V14.628H24.4138V17.004H22.2138V21.558H25.2718V24H19.8378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExe);
export default __webpack_public_path__ + "static/media/exe.b27464c8af5f4d0316632ed6d683a5a8.svg";
export { ForwardRef as ReactComponent };